const CHECK_NEW_ORDERS_PENDING = "CHECK_NEW_ORDERS_PENDING";
const CHECK_NEW_ORDERS_PENDING_SUCCESS = "CHECK_NEW_ORDERS_PENDING_SUCCESS";
const CHECK_NEW_ORDERS_PENDING_REFRESH_TIME_STAMP =
  "CHECK_NEW_ORDERS_PENDING_REFRESH_TIME_STAMP";
const CHECK_NEW_ORDERS_PENDING_FAILURE = "CHECK_NEW_ORDERS_PENDING_FAILURE";
const CLEAR_CHECK_NEW_ORDERS_PENDING = "CLEAR_CHECK_NEW_ORDERS_PENDING";
const checkNewOrdersPendingSymbols = {
  CHECK_NEW_ORDERS_PENDING_SUCCESS,
  CHECK_NEW_ORDERS_PENDING_FAILURE,
  CHECK_NEW_ORDERS_PENDING,
  CHECK_NEW_ORDERS_PENDING_REFRESH_TIME_STAMP,
  CLEAR_CHECK_NEW_ORDERS_PENDING,
};
export default checkNewOrdersPendingSymbols;
